<div class="card card-statistics mb-30">
  <div class="card-body">
    <h5 class="card-title">Certificate Notes</h5>
    <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1"> Note </label>
        <select [(ngModel)]="Seleted_Note_Id" name="Seleted_Note_Id" class="custom-select">
          <option value="">Select</option>
          <option *ngFor="let item of DataList_CertificateNote|filter:Filter_Dsc:'dsc'" value="{{item.id}}">{{item.dsc}}</option>

        </select>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Search Notes</label>
        <input [(ngModel)]="Filter_Dsc" (keyup)="Change_Filter_title()" type="text" class="form-control" placeholder="Type here...">
      </div>

    </div>
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button *ngIf="!InProccessing" (click)="SubmitCertificate()" type="button" [disabled]="!Seleted_Note_Id" class="btn btn-success"
      style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Note </button>

    <div class="table-responsive">
      <table class="mb-0 table table-bordered table-3 text-center table-striped">
        <thead style="background-color: #489b39; color: white;">
          <tr>
            <th>#</th>
            <th>Code</th>
            <th>Text</th>

            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of Selected_DataList_CertificateNote">
            <td>{{Selected_DataList_CertificateNote.indexOf(item)+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.dsc}}</td>
            <td>
              <button type="button" class="btn btn-danger" (click)="DeleteCertificateNote(item.id)"> Delete </button>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>